const getMethodSent = (method, uiData) => {
  if (uiData && uiData.correspondence && uiData.correspondence.methodSent) {
    return uiData.correspondence.methodSent[method] ? uiData.correspondence.methodSent[method] : '';
  }
  return '';
};

export default getMethodSent;
